import { createSelector } from 'reselect'
import { selectTicketsById } from 'selectors/tickets'

export const selectDirection = state => state.merge.direction

export const selectTargetTicketId = state => state.merge.targetTicketId

export const selectChildTicketIds = state => state.merge.childTicketIds

export const selectMergeId = state => state.merge.mergeId

export const selectTargetTicket = createSelector(
  selectTargetTicketId,
  selectTicketsById,
  (id, tickets) => id && tickets[id]
)

export const selectChildTickets = createSelector(
  selectChildTicketIds,
  selectTicketsById,
  (ids, tickets) => ids && ids.map(id => tickets[id])
)
